import {
  addCpfMask,
  convertDateToBrazilFormat,
  generateAvatarInitialsImage,
} from '@repo/ui';
import { GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS } from 'domain/models';
import { GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

export const makeTcesSentToIntegrativeColumns = (): TableColumn<
  GetPaginatedOrganizationTcesSentToIntegrativeUseCaseInterface.Result['tces'][number]
>[] => {
  return [
    {
      name: 'Estudante',
      width: '20%',
      sortable: true,
      sortField:
        GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS.NAME,
      wrap: true,
      selector: (row) => row.name,
      cell: ({ photo, name, cpf }) => (
        <div className="d-flex align-items-center gap-2">
          <img
            src={photo || generateAvatarInitialsImage(name)}
            className="rounded-circle avatar-xs user-profile-image"
          />
          <div>
            <p className="m-0">{name}</p>
            <p className="m-0 text-muted">{addCpfMask(cpf)}</p>
          </div>
        </div>
      ),
    },
    {
      name: 'Grupo',
      selector: (row) => row.groupName,
      sortField:
        GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS.GROUP_NAME,
      wrap: true,
      sortable: true,
      cell: ({ groupName, groupCode }) => `${groupName} - ${groupCode}`,
    },
    {
      name: 'Local de Estágio',
      selector: (row) => row.internshipLocationName,
      sortField:
        GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS.INTERNSHIP_LOCATION_NAME,
      wrap: true,
      sortable: true,
    },
    {
      name: 'Período de Estágio',
      selector: (row) => row.duration,
      sortField:
        GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS.PERIOD,
      wrap: true,
      sortable: true,
      cell: ({ startsAt, endsAt, duration }) => {
        return (
          <div>
            <p className='mb-1'>
              {startsAt ? convertDateToBrazilFormat(startsAt) : '--'} -{' '}
              {endsAt ? convertDateToBrazilFormat(endsAt) : '--'}
            </p>
            <p className="m-0">
              {duration ? (duration > 1 ? `${duration} meses` : '1 mês') : '--'}
            </p>
          </div>
        );
      },
    },
    {
      name: 'Assinaturas',
      selector: ({
        hasStudentSigned,
        hasGrantorSigned,
        hasInstitutionSigned,
      }) => hasStudentSigned && hasGrantorSigned && hasInstitutionSigned,
      wrap: true,
      cell: ({ hasStudentSigned, hasGrantorSigned, hasInstitutionSigned }) => (
        <div className="d-flex flex-wrap gap-2">
          {hasStudentSigned && (
            <Badge color="primary" >
              Estudante
            </Badge>
          )}
          {hasGrantorSigned && (
            <Badge color="secondary">
              Concedente
            </Badge>
          )}
          {hasInstitutionSigned && (
            <Badge color="warning">
              Instituição
            </Badge>
          )}
        </div>
      ),
    },
    {
      name: 'Última atualização',
      selector: (row) => row.updatedAt,
      sortField:
        GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS.UPDATED_AT,
      wrap: true,
      sortable: true,
      cell: ({ updatedAt }) => (
        <div>
          <p>{updatedAt ? convertDateToBrazilFormat(updatedAt) : '--'}</p>
        </div>
      ),
    },
  ];
};
